import { api } from "../../../Api"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const loginThunk = createAsyncThunk('user/login', async (values) => {
    const res = await api.login(values) 
    localStorage.setItem('access_token', res.access_token)
    localStorage.setItem('refresh_token', res.refresh_token)
    return await res
})

export const authThunk = createAsyncThunk('user/auth', async () => {
    // localStorage.setItem('access_token', 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiYWNjZXNzX3Rva2VuIiwic3ViIjoiMSIsImxvZ2luIjoicm9vdCIsInJvbGVfaWQiOjEsInJvbGVfbmFtZSI6IkFETUlOIiwiYnJhbmNoX2lkIjoxLCJicmFuY2hfbmFtZSI6IlNFVl9aQVAiLCJleHAiOjE3MzQwODUxODYsImlhdCI6MTczNDA4NTEyNn0.E-WK26m2zdENjKIAKLLkSOhEuI6jMuUfp2ZJ3K-njaSzACg0S3-NDlfHwjW_sbhlclOcIDM16rhgU9EeGSnhW65LP5Z82pH6bSO21_VyBtRlJTnJ5Jnsd97L37PjMFIgPPqz2_K4lZY4-RhEcF7iUkeP38TE5L-7z_GuVbQw2vbUJ_3f2BHN23MawW8NCA1vmO1VR-7yPqHarlZvhghl04uGZBbvW2R2si7MtVVsCbFnzsRhmIdGahaCNqzLyjs6SFw8ouGp1RBfkhw552wlENOHnpcRyA6UKiN8GkOOx82RR2HI27dAUOCS-KwVzy3FrHeLqBWr39iVODP50UVyPA')
    let res = await api.auth()
    if(res.detail){
        res = await refreshToken()
    }        
    return await res
})

export const getRegionThunk = createAsyncThunk('user/region', async (_, {rejectWithValue}) => {
    try{
        return await api.getRegions()
    } catch(e){
        return rejectWithValue(e)
    }
})


export const authToken = async () => {
    return await api.auth()
}

export const refreshToken = async () => {
    const res = await api.refresh()
    console.log(res);
    if(res.access_token){
        localStorage.setItem('access_token', res.access_token)
        return await authToken()
    }
    else {
        return res
    }
}

export const UserBuilder = (builder) => {
    // login
    builder.addCase(loginThunk.fulfilled, (state) => {
        state.error = null
        state.auth = true
    }).addCase(loginThunk.rejected, (state, action) => {
        state.error = action.payload
        state.auth = false
    })

    // auth
    .addCase(authThunk.fulfilled, (state, action) => {
        const {detail} = action.payload
        if(detail) return
        state.user = action.payload
        // state.location = {name : action.payload.users_city_name, location : action.payload.user_location}
        api.headers['Authorization'] = `Bearer ${action.payload.token}`
    }).addCase(authThunk.rejected, (state, action) => {
        state.error = action.payload
        state.user = null
    })

    .addCase(getRegionThunk.fulfilled, (state, action) => {        
        state.regions = Object.entries(action.payload).map((item) => ({name : item[0], location : item[1]}))
        state.error = null
    }).addCase(getRegionThunk.rejected, (state, action) => {
        state.error = 'Произошла ошибка при получении регионов'
    })
    
}